export const CONVERSATION_SOURCE_TYPES = {
  bot: 'bot',
  support: 'support',
  user: 'user',
}
